<template>
  <section :class="{ 'fill-landing': name !== '' }">
    <Form v-if="name !== ''" />
  </section>
</template>

<script>
import axios from "axios";
import Button from "@/components/Button";
import Landing from "@/components/Landing";
import Form from "@/components/Form";
import Footer from "@/components/Footer";

export default {
  name: "Book",
  components: {
    Button,
    Landing,
    Form,
    Footer,
  },
  data() {
    return {
      name: "",      
    };
  },
  created() {    
     window.addEventListener('scroll', this.handleScroll);
    const params = new URLSearchParams();
    params.append("purl", this.$route.params.purl);
    params.append("appt", '');
    axios
      .post(`${this.$store.state.API}/Purl.php`, params)
      .then(this.onGetPurl);
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    onGetPurl(response) {
      if (response.data.status === "ok") {
        this.name = response.data.first;        
        this.$store.commit("setRepId", response.data.id);
        this.$store.commit("setSelectedSchedule", response.data.schedules[0].value);
      }
    },
    handleScroll (event) {
      if(window.scrollY === 0) {
        document.location.hash = '';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.book {
  margin-top:36px;
}
.welcome {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  color: var(--white);
  font-size: 1.25rem;
  margin: 0;
  padding: 1rem;
  font-family: 'Alternate Gothic No3 D';
}
section {
  display: flex;
  flex-direction: column;
  &:not(.fill-landing) {
    min-height: 100vh;    
  }
  &.fill-landing {
    .landing {
      min-height: 100vh;
    }
  }
}
</style>